// Handle functionality of tabs
class accordionTabs {
    constructor(element) {
        // Find all necessary elements
        this.element = element;
        this.tabsWrapper = document.querySelector(`[data-tabs="wrapper"]`);
        this.contentWrapper = document.querySelector(`[data-tabs="content-wrapper"]`);

        // Get tabs
        this.items = element.querySelectorAll(`[data-tabs="item"]`);

        // Init functionalities if all elements has been found
        if ((this.tabsWrapper && this.items.length > 1) && this.contentWrapper) {
            //this.tabsWrapper.style.minHeight = this.tabsWrapper.offsetHeight+"px";
            this.contentWrapper.style.minHeight = this.contentWrapper.offsetHeight+"px";
            this.init();
        }
        else {
            console.error("missing elements to properly init accordionTabs")
        }
    }

    init() {

        // Add functionality to show content on click of item
        this.items.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();

                // on click show itemContent 
                this.showContent(item);
            });
        });

        // Get items tabs
        const inside_items = this.contentWrapper.querySelectorAll(`[data-tabs="inside-item"]`);

        // Add functionality to show content on click of item
        inside_items.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();

                // on click show itemContent 
                this.showInsideContent(item);
            });
        });
    }

    showContent(item) {
        const isActive = item.getAttribute('data-active');

        if (isActive == 'false') {

            // Get item id
            const id = item.getAttribute('data-id');

            // find all active items and contents
            const activeElemnets = this.tabsWrapper.querySelectorAll(`[data-tabs="item"][data-active="true"]`);
            const activeContents = this.tabsWrapper.querySelectorAll(`[data-tabs="content"][data-active="true"]`);
    
            // remove class and attributes if found active elements
            if (activeElemnets.length > 0) {
                activeElemnets.forEach(activeElemnet => {
                    activeElemnet.setAttribute("data-active", "false");
                    activeElemnet.classList.remove("active");
                });
            }

            // remove class and attributes if found active contents
            if (activeContents.length > 0) {
                activeContents.forEach(activeContent => {
                    activeContent.setAttribute("data-active", "false");
                    activeContent.classList.remove("active");
                });
            }

            // find all active Inside items and contents
            const activeInsideElemnets = this.tabsWrapper.querySelectorAll(`[data-tabs="inside-item"][data-active="true"]`);
            const activeInsideContents = this.tabsWrapper.querySelectorAll(`[data-tabs="inside-content"][data-active="true"]`);
    
            // remove class and attributes if found active elements
            if (activeInsideElemnets.length > 0) {
                activeInsideElemnets.forEach(activeElemnet => {
                    activeElemnet.setAttribute("data-active", "false");
                    activeElemnet.classList.remove("active");
                });
            }

            // remove class and attributes if found active contents
            if (activeInsideContents.length > 0) {
                activeInsideContents.forEach(activeContent => {
                    activeContent.setAttribute("data-active", "false");
                    activeContent.classList.remove("active");
                });
            }

            // Active this item
            item.setAttribute("data-active", "true");
            item.classList.add("active");

            // Find content for this item
            const itemContent = this.contentWrapper.querySelector(`[data-tabs="content"][data-id="${id}"]`);

            if (itemContent) {
                // Active this content
                itemContent.setAttribute("data-active", "true");
                itemContent.classList.add("active");

                const insideItem = itemContent.querySelector(`[data-item="top-nav-item"]:first-child [data-tabs="inside-item"]`);
                insideItem.click(); 
            }

            const contentWrapper = this.contentWrapper;
            setTimeout(function () {
                const height = itemContent.offsetHeight;
                contentWrapper.style.minHeight = height+"px";
            }, 700);
        }

    }

    showInsideContent(item) {
        const isActive = item.getAttribute('data-active');

        if (isActive == 'false') {

            // Get item id
            const id = item.getAttribute('data-id');

            // find all active items and contents
            const activeElemnets = this.tabsWrapper.querySelectorAll(`[data-tabs="content"][data-active="true"] [data-tabs="inside-item"][data-active="true"]`);
            const activeContents = this.tabsWrapper.querySelectorAll(`[data-tabs="content"][data-active="true"] [data-tabs="inside-content"][data-active="true"]`);
    
            // remove class and attributes if found active elements
            if (activeElemnets.length > 0) {
                activeElemnets.forEach(activeElemnet => {
                    activeElemnet.setAttribute("data-active", "false");
                    activeElemnet.classList.remove("active");
                });
            }

            // remove class and attributes if found active contents
            if (activeContents.length > 0) {
                activeContents.forEach(activeContent => {
                    activeContent.setAttribute("data-active", "false");
                    activeContent.classList.remove("active");
                });
            }

            // Active this item
            item.setAttribute("data-active", "true");
            item.classList.add("active");

            // Find content for this item
            const itemContent = this.contentWrapper.querySelector(`[data-tabs="content"][data-active="true"] [data-tabs="inside-content"][data-id="${id}"]`);

            if (itemContent) {
                // Active this content
                itemContent.setAttribute("data-active", "true");
                itemContent.classList.add("active");
            }

            const contentWrapper = this.contentWrapper;
            setTimeout(function () {
                const height = itemContent.offsetHeight;
                contentWrapper.style.minHeight = height+"px";
            }, 700);
        }

    }
}

window.addEventListener('load', () => {
    // Get all tabs tabs that need to use this functionality
    const tabsWrapper = document.querySelectorAll(`[data-tabs="wrapper"]`);
    if (tabsWrapper.length > 0) {
        tabsWrapper.forEach(tabs => {
            // Find all tabs elements
            const tabsElements = tabs.querySelectorAll(`[data-tabs="items"]`);
            
            tabsElements.forEach(element => {
                // Init functionality for every element
                new accordionTabs(element);
            })
        })
    }
})